/* eslint-disable */
import axios from "axios";
import Vue from "vue";
import router from "@/router";
import SocketHolder from "../../SocketHolder";
// import { recognitionLanguages } from "../../constants";
import { getSoundSelectorSettingValue } from "../../util";
import {
  CORE_ALERT_ENABLED,
  CORE_CONNECT_ENABLED,
  CORE_COMMUNICATOR_ENABLED,
  CONVEY_COMMUNICATOR,
  CONVEY_ALERT,
  CONVEY_CONNECT,
} from "../../constants";

axios.defaults.headers.common["Content-Type"] = "application/json";

export default {
  namespaced: true,
  state: {
    agency: null,
    voiceDialects: [],
    textDialects: [],
    onlineAgents: [],
    messageTemplates: [],
    settings: {},
    feedStatus: "offline",
    agencyVideoRoomJoined: false,
    isAgencyConnecting: true,
    isSDKEnabled: false,
    agencyModules: [],
    selectedAgencyModule: null,
    lastSelectedModule: {},
    permissions: [],
  },
  getters: {
    currentAgency: (state) => state.agency,
    currentAgencyId: (state) => {
      if (state.agency && state.agency.agency_id) return state.agency.agency_id;
    },
    voiceDialects: (state) => state.voiceDialects,
    textDialects: state => state.textDialects,
    messageTemplates: (state) => state.messageTemplates,
    agencySettings: (state) => state.settings,
    availableAgents: (state) => {
      return state.onlineAgents.filter(
        (agent) =>
          Math.floor(Date.now() / 1000) -
            Math.floor(Date.now(agent.updatedAt) / 1000) <
          90
      );
    },
    agencyLogo: (state) => {
      if (
        state.settings &&
        state.settings.agencyLogo &&
        state.settings.agencyLogo &&
        typeof state.settings.agencyLogo === "string"
      )
        return state.settings.agencyLogo;
      else return "/images/heroicon-badge.png";
    },
    numbers: (state) =>
      state.agency.numbers
        .filter((number) => number.outbound === true)
        .sort((a, b) => a.preference - b.preference),
    isAgencyConnecting: (state) => state.isAgencyConnecting,
    isSDKEnabled: (state) => state.isSDKEnabled,
    agencyModules: state => state.agencyModules,
    selectedAgencyModule: state => state.selectedAgencyModule,
    lastSelectedModule: state => state.lastSelectedModule,
    permissions: state => state.permissions,
  },
  actions: {
    async bindAgencySession({ commit, dispatch, rootState }, params) {
      let sessionId = params.sessionId;
      let agencyId = params.agencyId;

      commit("setIsAgencyConnecting", true);

      if (!sessionId || !agencyId) {
        commit("setIsAgencyConnecting", false);
        throw new Error(
          "Can't bind session without required params - sessionId and/or agencyId missing"
        );
      }

      if (Vue.prototype.$conveyInstance && Vue.prototype.$conveyInstance.endRadio) {
        Vue.prototype.$conveyInstance.endRadio();
      }

      if (rootState.user.isEmbedSDKLoaded) {
        await Vue.prototype.$unloadScript(`${process.env.VUE_APP_CONVEY_SDK_HOST}/index.js`)
          .then(() => {
            commit("user/setIsEmbedSDKLoaded", false, { root: true });
            Vue.prototype.$conveyInstance = null;
          })
          .catch(() => {
            commit("user/setIsEmbedSDKLoaded", false, { root: true });
          });
      }

      try {
        const resp = await Vue.prototype.$ConveyApi.sessionsApi.bindUserSessionToAgency({
          sessionId,
          payload: { agency_id: agencyId },
        });
        const agencySession = resp.data.data;
        commit('setPermissions', agencySession.permissions);

        Vue.prototype.$cookie.set(
          "x-current-agency",
          agencySession.agency_id
        );
        
        commit("setIsSDKEnabled", false);
        commit("setAgencyModules", []);

        if (resp.status === 200) {
          const agencySettings = {...agencySession.agency.settings};
          const agencySecret = agencySession.agency ? agencySession.agency.agency_secret : null;
          if (agencySettings["core:communicatorEnabled"] === true || agencySettings["core:communicatorEnabled"] === "true") {
            commit("setIsSDKEnabled", true);
            Vue.prototype.$loadScript(`${process.env.VUE_APP_CONVEY_SDK_HOST}/index.js`)
              .then(() => {
                commit("user/setIsEmbedSDKLoaded", true, { root: true });
                Vue.prototype.$conveyInstance = window.Convey.SDK.init({
                  agencyId,
                  agencySecret,
                  userJwt: rootState.user.token,
                  forceInit: true,
                  options: {
                    showModal: true,
                    verticalVideo: false,
                    disableConveyConnect: false,
                    disableVideoCall: false,
                    disableLocationRequest: false,
                    disableVideoTranscribe: false,
                    enableSentimentAnalysis: false,
                    enableKeywordBubbles: false,
                    openLastActiveChat: false,
                    disableShowLiveAudio: true,
                    enableInterpreter: true,
                    enableVoice2Voice: true
                  },
                });
                console.log(`Initialized conveyInstance ${agencyId}`, Vue.prototype.$conveyInstance);
              })
              .catch((err) => {
                console.log("Error", err);
                commit("user/setIsEmbedSDKLoaded", false, { root: true });
              });
          }

          commit("user/setUserSession", agencySession.session.session_id, {
            root: true,
          });
          if (agencySession.session.position && agencySession.session.position.position_id && agencySession.session.position.user_id === rootState.user.user.user_id) {
            dispatch("user/updateCallTakerMode", agencySession.session.position, { root: true });
          } else {
            dispatch("user/updateCallTakerMode", null, { root: true });
          }
          commit("setCurrentAgency", agencySession.agency);
          dispatch("updateAgencySettings", agencySettings);

          if (agencySettings.prizymBrandEnabled) {
            document.body.setAttribute('data-ui', 'prizym');
          } else {
            document.body.setAttribute('data-ui', 'convey');
          }

          if (agencySettings['core:alertEnabled']) {
            await dispatch("campaigns/fetchCampaigns", agencySession.agency_id, { root: true });
          } else {
            commit("campaigns/setCurrentCampaign", null, { root: true });
            commit("campaigns/setCurrentCampaigns", [], { root: true });
            commit("campaigns/setCurrentCampaignEvents", [], { root: true });
          }

          await dispatch(
            "conversations/fetchConversations",
            agencySession.agency_id,
            { root: true }
          );
          dispatch("fetchDialects");
          dispatch("fetchMessageTemplates");
          dispatch("fetchAgents");
          SocketHolder.socket.emit("connectAgencyFeed", {
            agencyId: agencySession.agency_id,
            token: rootState.user.token,
            sessionId: rootState.user.session.session_id
          });
          commit("setFeedStatus", "online");
        }

        commit("setIsAgencyConnecting", false);
      } catch (err) {
        commit("setIsAgencyConnecting", false);
        if (err.response.status === 403 && err.response.data && err.response.data.data && err.response.data.data['error']) {
          Vue.prototype.$toastr(
            "error",
            err.response.data.data['error']
          );
          throw new Error(err.response.data.data['error']);
        } else {
          Vue.prototype.$toastr(
            "error",
            "Error establishing a new session with your agency tenant. Please try again."
          );
          throw new Error("Error establishing a new session with your agency tenant. Please try again.");
        }
      }
    },
    async fetchAgents({ state, rootState, commit }) {
      commit("clearAgents");
      const headers = {
        Authorization: `Bearer ${rootState.user.token}`,
        "x-agency-id": state.agency.agency_id,
      };
      const resp = await axios.get(`${this._vm.$apihost}/sessions`, {
        headers: headers,
      });
      const agents = resp.data.data;
      for (var i = 0; i < agents.length; i++) {
        if (agents[i].ttl > 0)
          commit("addAvailableAgent", {
            agentId: agents[i].user_id,
            agentName: `${agents[i].fname} ${agents[i].lname}`,
            socketId: agents[i].socket_id,
            sessionId: agents[i].session_id,
            updatedAt: new Date(agents[i].updated_at).getTime(),
          });
      }
    },
    async fetchDialects({ commit, rootState }) {
      try {
        commit("clearDialects");
        const headers = {
          Authorization: `Bearer ${rootState.user.token}`,
        };
        const voiceDialectsResponse = await axios.get(`${this._vm.$apihost}/text_translate?voice=true&text=false`, {
          headers: headers,
        });
        const textDialectsResponse = await axios.get(`${this._vm.$apihost}/text_translate?voice=false&text=true`, {
          headers: headers,
        });
        commit("setDialects", {
          textDialects: textDialectsResponse.data.data,
          voiceDialects: voiceDialectsResponse.data.data,
        });
      } catch(err) {
        console.log("[fetchDialects:ERROR]: ", err);
      }
    },

    async fetchMessageTemplates({ commit, rootState }) {
      commit("clearMessageTemplates");
      const headers = {
        Authorization: `Bearer ${rootState.user.token}`,
      };

      const resp = await axios.get(
        `${this._vm.$apihost}/agencies/${this.state.agency.agency.agency_id}/templates`,
        { headers: headers }
      );
      const templates = resp.data.data;
      commit("setMessageTemplates", templates);
    },

    updateAgency({ commit }, agency) {
      commit("setCurrentAgency", agency);
      commit("setIsAgencyConnecting", false);
    },

    updateAgencySettings({ commit, state }, settings) {
      commit("storeAgencySettings", settings);

      let {
        videoJoinedNotificationSound,
        videoLeftNotificationSound,
        voiceNotificationSound,
        textNotificationSound,
        textTo911NotificationSound,
        messageNotificationSound
      } = settings;

      videoJoinedNotificationSound = getSoundSelectorSettingValue(videoJoinedNotificationSound);
      videoLeftNotificationSound = getSoundSelectorSettingValue(videoLeftNotificationSound);
      voiceNotificationSound = getSoundSelectorSettingValue(voiceNotificationSound);
      textNotificationSound = getSoundSelectorSettingValue(textNotificationSound);
      messageNotificationSound = getSoundSelectorSettingValue(messageNotificationSound);
      textTo911NotificationSound = getSoundSelectorSettingValue(textTo911NotificationSound);

      const userSoundSelectorSetting = {
        videoJoinedNotificationSound: {
          label: "Video Participant Joined",
          enabled: !!videoJoinedNotificationSound,
          value: videoJoinedNotificationSound,
        },
        videoLeftNotificationSound: {
          label: "Video Participant Left",
          enabled: !!videoLeftNotificationSound,
          value: videoLeftNotificationSound,
        },
        voiceNotificationSound: {
          label: "New Inbound Voice Conversation",
          enabled: !!voiceNotificationSound,
          value: voiceNotificationSound,
        },
        textNotificationSound: {
          label: "New Inbound SMS Conversation",
          enabled: !!textNotificationSound,
          value: textNotificationSound,
        },
        textTo911NotificationSound: {
          label: "New Inbound Text-to-911 Conversation",
          enabled: !!textTo911NotificationSound,
          value: textTo911NotificationSound,
        },
        messageNotificationSound: {
          label: "Inbound Message Notification",
          enabled: !!messageNotificationSound,
          value: messageNotificationSound,
        },
      };
      
      commit("user/updateSoundSelectorSetting", userSoundSelectorSetting, {
        root: true,
      });

      const modules = [];
      if (settings[CORE_COMMUNICATOR_ENABLED]) {
        modules.push(CONVEY_COMMUNICATOR);
      } 
      if (settings[CORE_ALERT_ENABLED]) {
        modules.push(CONVEY_ALERT);
      }
      if (settings[CORE_CONNECT_ENABLED]) {
        modules.push(CONVEY_CONNECT);
      }

      commit("setAgencyModules", modules);
      
      if (state.selectedAgencyModule) {
        const findCurrentModule = modules.find(module => module.name === state.selectedAgencyModule.name);
        if (!findCurrentModule) {
          commit("setSelectedAgencyModule", null);
          router.push({ path: "/" }).catch(() => {});
        }
      }
    },
  },
  mutations: {
    clearAgents: (state) => (state.onlineAgents = []),
    clearDialects: (state) => {
      state.voiceDialects = [];
      state.textDialects = [];
    },
    clearMessageTemplates: (state) => (state.messageTemplates = []),
    setFeedStatus: (state, status) => (state.feedStatus = status),
    setCurrentAgency: (state, currentAgency) => (state.agency = currentAgency),
    setDialects: (state, dialects) => {
      const getOrderdedDialects = (dialects) => {
        const originDialects = [...dialects];
        const engOptionIndex = originDialects.findIndex(option => option.code === "en");
        const engOption = engOptionIndex >= 0 ? {...originDialects[engOptionIndex]} : null;
        if (engOptionIndex >= 0) {
          originDialects.splice(engOptionIndex, 1);
        }
        const esOptionIndex = originDialects.findIndex(option => option.code === "es");
        const esOption = esOptionIndex >= 0 ? {...originDialects[esOptionIndex]} : null;
        if (esOptionIndex >= 0) {
          originDialects.splice(esOptionIndex, 1);
        }
        return [engOption, esOption, ...originDialects];
      };
      const { voiceDialects, textDialects } = dialects;
      if (voiceDialects) {
        state.voiceDialects = getOrderdedDialects(voiceDialects);
      }
      if (textDialects) {
        state.textDialects = getOrderdedDialects(textDialects);
      }
    },
    setMessageTemplates: (state, templates) =>
      (state.messageTemplates = templates),
    storeAgencySettings: (state, settings) => {
      let agencySetting = {};
      for (const [k, v] of Object.entries(settings)) {
        agencySetting[k] = typeof v === "object" ? v["value"] : v;

        if (agencySetting[k] === "true" || agencySetting[k] === "false")
          agencySetting[k] = agencySetting[k] === "true" ? true : false;
      }
      state.settings = agencySetting;
      if (state.settings.agencyLogo && state.settings.agencyLogo)
        Vue.prototype.$cookie.set("x-agency-logo", settings.agencyLogo);
    },
    setAgencyVideoRoomJoined: (state, joined) => {
      state.agencyVideoRoomJoined = joined;
    },
    addAvailableAgent: (state, agent) => {
      const index = state.onlineAgents.findIndex(
        (a) => a.socketId === agent.socketId
      );
      if (index === -1) {
        state.onlineAgents.push(agent);
      }
    },
    removeAvailableAgent: (state, params) => {
      state.onlineAgents = state.onlineAgents.filter(
        (agent) =>
          (params.socketId && agent.socketId != params.socketId) ||
          (params.agentId && agent.agentId != params.agentId)
      );
    },
    touchAvailableAgent: (state, agent) => {
      const index = state.onlineAgents.findIndex(
        (a) => a.agentId === agent.agentId
      );
      if (index !== -1) {
        state.onlineAgents[index].updatedAt = parseInt(agent.updatedAt);
      }
    },
    setIsAgencyConnecting: (state, value) => (state.isAgencyConnecting = value),
    setIsSDKEnabled: (state, value) => { state.isSDKEnabled = value },
    setAgencyModules: (state, modules) => { state.agencyModules = modules },
    setSelectedAgencyModule: (state, module) => { state.selectedAgencyModule = module },
    setLastSelectedModule: (state, data) => {
      const { agencyId, module } = data;
      if (state.lastSelectedModule[agencyId]) {
        delete state.lastSelectedModule[agencyId];
      }
      state.lastSelectedModule[agencyId] = { ...module };
    },
    setPermissions(state, permissions) {
      if (Array.isArray(permissions) && permissions.length > 0) {
        state.permissions = permissions;
      } else {
        state.permissions = [];
      }
    }
  },
};
